const siteConfig = {
  brandName: "dartember",
  logoText: "dartember",
  logo: {
    text: "dartember",
    alt: "dartember — original notebooks and journals",
  },
  description:
    "Original notebooks and journals designed for everyday ideas, plans, and sketches.",
  contact: {
    email: "scope@dartember.shop",
    supportEmail: "scope@dartember.shop",
    address: {
      line1: "Unit 1603, 16/F, The L. Plaza",
      city: "Hong Kong",
      region: "Kowloon",
      postalCode: "000000",
      country: "Hong Kong SAR",
    },
    hours: "Monday–Friday, 9:00 AM–6:00 PM HKT",
  },
  currency: "USD",
  currencySymbol: "$",
  locale: "en-US",
  shipping: {
    freeThreshold: null,
    standardRate: 9.99,
    expeditedRate: 19.99,
  },
  socialLinks: [],
  navigation: {
    header: [
      { label: "New", path: "/shop?sort=newest" },
      { label: "Shop", path: "/shop" },
      { label: "Best Sellers", path: "/shop?collection=best-sellers" },
      { label: "Artists", path: "/about#artists" },
      { label: "Our Story", path: "/about" },
    ],
    shop: [
      { label: "All Notebooks", path: "/shop" },
      { label: "Classic Notebooks", path: "/shop?category=classic-notebooks" },
      { label: "Layflat Journals", path: "/shop?category=layflat-journals" },
      { label: "Sketchbooks", path: "/shop?category=sketchbooks" },
      { label: "Mini Notebooks", path: "/shop?category=mini-notebooks" },
      { label: "Spiral Notebooks", path: "/shop?category=spiral-notebooks" },
    ],
    company: [
      { label: "About", path: "/about" },
      { label: "Contact", path: "/contact" },
      { label: "Meet the Artists", path: "/about#artists" },
    ],
    help: [
      { label: "Shipping", path: "/shipping" },
      { label: "Returns", path: "/returns" },
      { label: "Privacy", path: "/privacy" },
      { label: "Terms", path: "/terms" },
      { label: "FAQs", path: "/faqs" },
      { label: "Cookie Policy", path: "/cookies" },
    ],
  },
};

export { siteConfig };
export default siteConfig;
